export default "__VITE_ASSET__aiMai3b3__"